/**
 * LA POLITIQUE DE MOT DE PASSE — UNE SEULE (LOT-H6/DA-007, puis LOT-MDP-8).
 *
 * ══════════════════════════════════════════════════════════════════════════
 * LA RÈGLE (décision produit ratifiée le 2026-08-25)
 * ══════════════════════════════════════════════════════════════════════════
 *
 * **8 caractères minimum, aucune autre exigence.** Unique dans TOUT le
 * produit, et désormais vraie des deux côtés :
 *
 *   - backend : `apps/backend/src/auth/password-policy.ts` (importé par tous
 *     les DTOs porteurs de mot de passe — change/reset/register/create-user/
 *     create-user-admin/update-user-admin/create-tenant). Le `@Matches` de
 *     composition (majuscule/minuscule/chiffre/spécial d'une liste FERMÉE
 *     @$!%*?&) qui gardait le changement de mot de passe est SUPPRIMÉ, et
 *     les anciens `MinLength(6)` sont morts ;
 *   - frontend : ce fichier fournit le seuil ; `utils/passwordStrength.ts`
 *     fournit `isPasswordValid` (= ce seuil, rien d'autre) et une jauge de
 *     force purement INDICATIVE.
 *
 * Historique (LOT-H6) : la recette DA-007 avait trouvé trois écrans, trois
 * formulations, deux règles serveur (6 et 8+composition) ; le front avait
 * unifié l'ANNONCE sur 8. LOT-MDP-8 unifie la règle elle-même, côté serveur
 * comme côté client.
 *
 * Textes : `common:password.policy` (« 8 caractères minimum ») pour les
 * aides/placeholder, `common:password.tooShort` pour l'erreur — FR et EN
 * symétriques. Aucun seuil ni texte local ailleurs.
 *
 * La règle ne joue qu'à la SAISIE d'un nouveau mot de passe : les mots de
 * passe existants ne sont pas concernés.
 */

/** Longueur minimale annoncée ET vérifiée côté client, partout. */
export const PASSWORD_MIN_LENGTH = 8
